import SigninMain from "./SignInMain";
import "./SignInDesktop.css";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import LEftGrfx from '../../images/LEftGrfx.webp'
// Served from public/ (fixed URL) so index.html can preload it; bump the version when the image changes
const shodh_ai = process.env.PUBLIC_URL + '/img/shodh_ai.v1.webp'
const mobileLogoFrame = process.env.PUBLIC_URL + '/img/mobile_frame.v1.webp'
// React 18.2 only passes fetchpriority through in lowercase; the spread keeps eslint's no-unknown-property quiet
const highPriority = { fetchpriority: 'high' }
// Same breakpoint as SignInDesktop.css and the preloads in index.html. Rendering only the visible
// image stops mobile from also downloading the hidden desktop graphic at high priority.
const mobileQuery = window.matchMedia('(max-width: 1024px)')
const subscribeMobile = (onChange) => {
    mobileQuery.addEventListener('change', onChange)
    return () => mobileQuery.removeEventListener('change', onChange)
}

import { backdropClasses, Grid, InputLabel, Typography } from "@mui/material";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { CardActionArea } from '@mui/material';
import shodh_automatic from '../../images/shodh_automatic.webp'
import ml from '../../images/ml.webp'
import ready_reports from '../../images/ready_reports.webp'
import user_friendly from '../../images/user_friendly.webp'
import advanced_analytical from '../../images/advanced_analytical.webp'
import dynamic_data_visualization from '../../images/dynamic_data_visualization.webp'
import customizable_reports from '../../images/customizable_reports.webp'
import cross_platform_compatibility from '../../images/cross_platform_compatibility.webp'
import Footer from "../Footer/Footer";


const SignInDesktop = (props) => {
    const isMobile = React.useSyncExternalStore(subscribeMobile, () => mobileQuery.matches)


    useEffect(() => {
        // props.showNavBar(true)
    }, [])



    const CardComponent = ({ imgSrc, title, description, style = { width: 'auto', margin: 'auto', marginTop: 6 } }) => {
        return (
            <Card sx={{ maxWidth: 345 }} style={{ height: '100%', width: '100%' }}>
                <CardActionArea>
                    <CardMedia
                        component="img"
                        height="140"
                        width="140"
                        image={imgSrc}
                        alt={title}
                        style={style}
                    />
                    <CardContent>
                        <Typography gutterBottom variant="h6" component="div">
                            {title}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                            {description}
                        </Typography>
                    </CardContent>
                </CardActionArea>
            </Card>
        )
    }
    return (
        <div className="sign-indesktop">
            <main className="left-graphic-frame">
                {isMobile ? (
                    <img
                        className="mobile_logo_frame"
                        {...highPriority}
                        width="1025"
                        height="267"
                        alt="Shodh-AI: Your AI Research Companion"
                        src={mobileLogoFrame}
                    />
                ) : (
                    <img
                        className="leftgrfx-icon"
                        loading="eager"
                        {...highPriority}
                        width="1280"
                        height="1280"
                        alt=""
                        src={shodh_ai}
                    />
                )}
                <div className="signin-main">
                    <SigninMain {...props} />

                </div>
            </main>
            <br></br> <br></br>
            {/* Bottom Project Description */}

            <Card variant="outlined" sx={{ borderRadius: 3, background: "linear-gradient(to right, #83a4d4, #b6fbff)" }}>
                <CardContent >
                    <Grid container padding={"20px 10px 0px 9px"} textAlign={"center"}>
                        <Grid item>
                            <p><b>&quot;Unleash the Power of Data with integrated artificial intelligence&quot;</b></p>

                            <p>
                                Welcome to Shodh-AI, the cutting-edge statistics software designed for students, researchers, and professionals alike.
                                With its intuitive interface and powerful features, Shodh-AI transforms complex data analysis into a seamless and insightful experience.
                                The power of AI helps you automatically select the appropriate tests, simplifying the statistical analysis and making research an enjoyable journey.
                            </p>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            <br></br>





            {/* <Card>
                <CardContent>

                    <Grid container justifyContent={"center"} padding={"20px 10px 0px 9px;"} >
                        <Grid item >
                            <p><b>&quot;Unleash the Power of Data with integrated artificial intelligence&quot;</b></p>

                            <p>Welcome to Shodh-AI, the cutting-edge statistics software designed for students, researchers, and professionals alike.
                                With its intuitive interface and powerful features, Shodh-AI transforms complex data analysis into a seamless and insightful experience.
                                The power of AI helps you automatically select the appropriate tests, simplifying the statistical analysis and making research an enjoyable journey.</p>
                        </Grid>
                    </Grid >
                </CardContent>

            </Card> */}

            <Grid container justifyContent={"center"} className="key_feature_section">
                <Grid item>
                    <InputLabel><h5><b>Key Features</b></h5></InputLabel>
                </Grid>
            </Grid>
            <Grid container m={'auto'} columnSpacing={2} rowSpacing={2} justifyContent={"center"} className="key_feature_section">
                <Grid item xs={12} sm={6} md={6} lg={4} className="key_fetures_card">
                    <CardComponent
                        title="Machine Learning Integration"
                        imgSrc={ml}
                        description="Harness the power of machine learning with built-in algorithms for analytics, test selection and report generation"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={4}>
                    <CardComponent
                        title="Ready reports"
                        imgSrc={ready_reports}
                        description="Shodh-AI provides you a report that is ready to go into your thesis or paper with printable tables, description of the results and interpretation of the results. Bye bye to the days of writing results manually"
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={4}>
                    <CardComponent
                        title="User-Friendly Interface"
                        imgSrc={user_friendly}
                        description="Navigate through your data with ease, thanks to a user-friendly dashboard that simplifies complex operations without compromising on functionality."
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={4}>
                    <CardComponent
                        title="Advanced Analytical Tools"
                        imgSrc={advanced_analytical}
                        description="Dive deep into your data with a wide range of commonly used statistical tests for hypothesis testing, and time-series data. We are constantly improvising the test list and will soon include regression analysis and covariate correction."
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={4}>
                    <CardComponent
                        title="Dynamic Data Visualization"
                        imgSrc={dynamic_data_visualization}
                        description="Create stunning, interactive charts and graphs that bring your data to life."
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={4}>
                    <CardComponent
                        title="Customizable Reports"
                        imgSrc={customizable_reports}
                        description="Detailed reports are generated in an editable Word format that allow you to highlight key insights and present your findings professionally."
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={4}>
                    <CardComponent
                        title="Cross-Platform Compatibility"
                        imgSrc={cross_platform_compatibility}
                        description="Access your data and continue your work from anywhere, with cloud-based synchronization across desktop, laptop or tablets in Windows, macOS, and Linux systems."
                    />
                </Grid>
            </Grid>
            <Footer />
        </div >
    );
};

export default SignInDesktop;